export default __webpack_public_path__ + "static/media/default_avatar_square.0adf1e5c.svg";